






























































































































import schema from 'async-validator'
import {
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  OptionGroup,
} from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

import { MIN_AGE } from '@/models/customer'
import Passenger from '@/models/passenger'
import RegistrationData from '@/models/registration-data'

import getAbilitiesFor from '@/abilities/passenger/abilities'
import GroupedErrorValidationMixin from '@/mixins/GroupedErrorValidationMixin.vue'
import { ProfileDataActionTypes } from '@/store/modules/profileData'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
  },
})
export default class PassengerForm extends mixins(GroupedErrorValidationMixin) {
  @Prop() passenger!: Passenger
  @Prop() submitCaption!: string
  @Ref() readonly passengerForm!: Form
  @Ref() readonly firstNameInput!: Input

  submitDisabled = false
  hasEmptyFields = true

  rules = {
    title: [{ required: true, message: 'Title is required' }],
    firstName: [{ required: true, message: 'First Name is required' }],
    lastName: [{ required: true, message: 'Last Name is required' }],
    age: [
      { required: true, message: 'Birth Year is required' },
      {
        type: 'number',
        max: this.maxBirthYear,
        message: 'Passenger must be at least 17 years old',
        trigger: 'change',
      },
    ],
    email: [{ type: 'email', message: 'Wrong email format' }],
    nationality: [{ required: true, message: 'Nationality is required' }],
  }

  readonly validator = new schema(this.rules)

  form: RegistrationData = {
    email: '',
    password: '',
    title: '',
    firstName: '',
    lastName: '',
    nationality: '',
    countryCode: '',
    tel: '',
    age: null,
  }

  get updatable() {
    return getAbilitiesFor(this.passenger).can('update', 'Passenger')
  }

  get yearOptions(): number[] {
    const years: number[] = []
    const currentYear = new Date().getFullYear()

    for (let n = MIN_AGE; n <= 100; n++) {
      years.push(currentYear - n)
    }

    return years
  }

  get nationalities() {
    return this.$store.getters.nationalities
  }

  get additionalParams(): { [key: string]: any } {
    return {
      fullName: `${this.form.firstName} ${this.form.lastName}`,
    }
  }

  get maxBirthYear() {
    return new Date().getFullYear() - MIN_AGE
  }

  get titleAndFirstNameErrorMessage(): string {
    let message = ''
    if (this.formErrors.title) {
      if (this.formErrors.firstName) {
        message = 'Title and First Name are required'
      } else {
        message = 'Title is required'
      }
    } else if (this.formErrors.firstName) {
      message = 'First Name is required'
    }
    return message
  }

  async submit() {
    try {
      await this.passengerForm.validate()
      this.$emit('on-submit', { ...this.form, ...this.additionalParams })
    } catch {
      return false
    }
  }

  focusFirstName() {
    setTimeout(() => this.firstNameInput.focus())
  }

  created() {
    this.$store.dispatch(ProfileDataActionTypes.LoadNationalities)

    if (this.passenger) {
      this.fillInForm()
    }

    this.hasEmptyFields = Object.values(this.form).some((v) => !v)
  }

  fillInForm() {
    const { form, passenger, $_ } = this
    const prefilledFields = $_.pick(
      passenger,
      Object.keys(form),
    ) as RegistrationData

    this.form = { ...form, ...prefilledFields }
  }
}
